<template>
  <div v-if="egress_profile" class="mt-4">
    <GradeRangeGroupSelector
      class="mt-2"
      :egress_profile_id="egress_profile.id"
      @selected_range_group="selectedRangeGroup"
    ></GradeRangeGroupSelector>
    <IndividualMatterGradesReportTable
      v-if="show_grade_table"
      :key="selected_grade_range_group"
      :egress_profile="egress_profile"
      :campuses_="campuses_"
      :cohorts_="cohorts_"
      :cohort_indices_="cohort_indices_"
      :grade_range_group="selected_grade_range_group"
      :student_status_="student_status_"
    >
    </IndividualMatterGradesReportTable>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "IndividualMatterReport",
  components: {
    IndividualMatterGradesReportTable: () =>
      import(
        "@/components/reports/TeachingReport/IndividualMatterGradesReport/IndividualMatterGradesReportTable"
      ),
    GradeRangeGroupSelector: () =>
      import("@/components/reports/TeachingReport/GradeRangeGroupSelector.vue"),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    cohorts_: {
      type: Array,
    },
    cohort_indices_: {
      type: Array,
      default: () => [],
    },
    campuses_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected_grade_range_group: null,
      show_grade_table: false,
    };
  },
  computed: {},
  methods: {
    selectedRangeGroup(grade_range_group_id) {
      this.selected_grade_range_group = grade_range_group_id;
      this.show_grade_table = true;
    },
  },
  created() {},
};
</script>

<style scoped>
</style>

